import Popper from "@mui/material/Popper";
import type { ReactNode } from "react";
import { useCallback } from "react";
import isMobile from "src/helpers/isMobile";

import { SwipeableContent } from "../../Default/LekUI/SwipableDrawer";

interface ContainerProps {
	anchorEl: HTMLElement | null;
	setAnchorEl: (el: HTMLElement | null) => void;
	id: string | undefined;
	open: boolean;
	onMouseLeave: () => void;
	children: ReactNode;
}

export default function Container({
	anchorEl,
	setAnchorEl,
	id,
	open,
	onMouseLeave,
	children,
}: ContainerProps) {
	const renderSwipableContent = useCallback(() => {
		return (
			<SwipeableContent isOpen={!!anchorEl} onClose={() => setAnchorEl(null)}>
				{children}
			</SwipeableContent>
		);
	}, [children, anchorEl, setAnchorEl]);

	const renderPopper = useCallback(() => {
		return (
			<Popper
				id={id}
				open={open}
				anchorEl={anchorEl}
				placement="bottom"
				onMouseLeave={onMouseLeave}
				className="z-index-9"
			>
				{children}
			</Popper>
		);
	}, [children, anchorEl, id, onMouseLeave, open]);

	if (isMobile()) {
		return renderSwipableContent();
	}

	return renderPopper();
}
